import { Component, OnInit, EventEmitter, Output, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'cygov-download-existing-files-modal',
  templateUrl: './download-existing-files-modal.component.html',
  styleUrls: ['./download-existing-files-modal.component.scss'],
  standalone: false,
})
export class DownloadExistingFilesModalComponent implements OnInit, OnChanges {
  @Input() allFiles;
  @Input() assessmentValue = 0;
  @Input() controlName: string;
  @Output()
  closeDownloadModalClicked: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() startDownloading: EventEmitter<boolean> = new EventEmitter<boolean>();

  showConfirmDialogBox = true;
  confirmDownloadFlag = false;
  showSuccessMessage = false;
  showModal = false;
  allFileNames: Array<string> = new Array<string>();

  constructor() {}

  ngOnInit() {
    for (const file of this.allFiles) {
      if (file.selected) {
        this.allFileNames = this.allFileNames.concat(file.fileName.split(','));
      }
    }
    // Automatically start download when component initializes
    if (this.allFileNames.length > 0) {
      this.downloadFiles();
    }
  }

  ngOnChanges() {
    if (this.assessmentValue === 100) {
      this.downloadCompleted();
    }
  }

  closeDeleteModal() {
    this.showConfirmDialogBox = true;
    this.confirmDownloadFlag = false;
    this.showSuccessMessage = false;

    this.closeDownloadModalClicked.emit(true);
  }
  downloadFiles() {
    this.startDownloading.emit(true);
    this.showConfirmDialogBox = false;
    this.showModal = false; // Keep modal hidden during download
  }
  downloadCompleted() {
    // Show modal with success message when download completes
    this.showModal = true;
    this.showSuccessMessage = true;
  }

  get artifactText() {
    return this.allFileNames.length === 1 ? 'artifact' : 'artifacts';
  }
}
